<template>
  <div class="loader" :style="{ display: !showLoader ? 'none' : 'flex' }">
    <div>
      <div class="lds-ripple"><div></div><div></div></div>
    </div>
  </div>
</template>
<script>
import Api from '@/services/api';

const { api } = Api;

export default {
  name: 'Loader',
  data() {
    return {
      showLoader: false,
      requests: [],
    };
  },
  mounted() {
    api.interceptors.request.use(
      (config) => { // Then
        this.requests.push(config);
        this.showLoader = true;
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return config;
      },
      (error) => { // Catch
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return Promise.reject(error);
      },
    );

    api.interceptors.response.use(
      (response) => { // Then
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return response;
      },
      (error) => { // Catch
        this.showLoader = false;
        this.requests.pop();
        if (this.requests.length === 0) {
          this.showLoader = false;
        }
        return Promise.reject(error);
      },
    );
  },
};
</script>

<style lang="scss">
.loader {
  position: fixed;
  width: calc(100% - 300px);
  height: calc(100vh - 70px);
  top: 70px;
  left: 300px;
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lds-ripple {
  display: block;
  position: relative;
  width: 150px;
  height: 150px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #0d6efd;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 75px;
    left: 75px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 150px;
    height: 150px;
    opacity: 0;
  }
}
</style>